import { connect } from 'react-redux';

import View from './';

const mapStateToProps = () => ({});

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/systems/container.js